import { Text } from 'blaze-ui/Text/Text'
import Styles from './StalePreviewOverlay.module.scss'
import { Animation } from 'blaze-components/Animations/Animation'
import analyzing from 'components/BrandVisualAnalysisProcessingModal/analyzing.json'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { CSSProperties } from 'react'

interface Props {
  label?: string
  style?: CSSProperties
}

export const StalePreviewOverlay = ({ label = 'Preparing post', style }: Props) => {
  const animationProps = { play: true, style: { width: 48, height: 48 } }
  return (
    <div className={Styles.stalePreviewOverlay} style={style}>
      <Animation animationData={analyzing} {...animationProps} />
      <Text variant="primary">
        {label}
        <LoadingEllipses />
      </Text>
    </div>
  )
}
